var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useId } from 'react';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import BaseDatePicker from '@libs/@core/components/date-picker/BaseDatePicker';
var BaseDatePickerFormV2 = function (props) {
    var id = props.id, label = props.label, labelProps = props.labelProps, name = props.name, required = props.required, placeholder = props.placeholder, rest = __rest(props, ["id", "label", "labelProps", "name", "required", "placeholder"]);
    var generateId = useId();
    var method = useFormContext();
    var idDatePicker = id !== null && id !== void 0 ? id : generateId;
    return (_jsxs(FormControl, { fullWidth: true, children: [label && (_jsxs(FormLabel, __assign({ htmlFor: idDatePicker }, labelProps, { children: [label, _jsx("span", { style: { color: 'red' }, children: required ? '*' : '' })] }))), _jsx(Controller, { name: name, control: method.control, render: function (_a) {
                    var _b;
                    var field = _a.field, error = _a.fieldState.error;
                    return (_jsxs(_Fragment, { children: [_jsx(BaseDatePicker, __assign({ id: idDatePicker, "aria-labelledby": idDatePicker, value: (_b = field === null || field === void 0 ? void 0 : field.value) !== null && _b !== void 0 ? _b : '' }, rest, { onChangeDate: field.onChange, placeholder: placeholder })), error && error.message && _jsx(FormHelperText, { error: true, children: error.message })] }));
                } })] }));
};
export default BaseDatePickerFormV2;
